import { useState } from "react";
import { ArticleCommentProperties, EArticleCommentStatus, EArticleReplyStatus } from "../../../../types/blog.type";
import { Col, Form, Row, Space, Spin, message } from "antd";
import { confirmModal } from "../../../../helpers/modal";
import { httpRequest } from "../../../../helpers/api";
import { getErrorMessage } from "../../../../helpers/errorHandler";
import CommentItem2 from "./CommentItem2";
import ModalAddCommentOrReply from "./ModalAddCommentOrReply";

export default function ListComment2({
	comments,
	showHideContent,
	onSuccess,
	articleId,
}: {
	comments: ArticleCommentProperties[];
	showHideContent?: boolean;
	onSuccess?: () => void;
	articleId: string;
}) {
	const [isLoading, setIsLoading] = useState(false);
	const initState = (comments ?? []).reduce((acc: any, item: any) => {
		acc[item.commentId] = false;
		return acc;
	}, {});
	const [showReply, setShowReply] = useState(initState);
	const [type, setType] = useState("");
	const [showModalAdd, setShowModalAdd] = useState(false);
	const [form] = Form.useForm();
	const [isActionLoading, setIsActionLoading] = useState(false);
	const [tempComment, setTempComment] = useState<ArticleCommentProperties>();

	const handleDelete = async (id: string, type: "comment" | "reply") => {
		try {
			setIsLoading(true);
			if (type === "comment") {
				await httpRequest.delete(`/article-comments/${id}`);
			} else {
				await httpRequest.delete(`/article-reply-comments/${id}`);
			}

			onSuccess?.();
		} catch (error) {
			message.error(getErrorMessage(error));
		} finally {
			setIsLoading(false);
		}
	};

	const doApproveOrReject = async (id: string, type: string, status: string) => {
		setIsActionLoading(true);

		try {
			const dto = {
				status,
			};
			if (type === "comment") {
				await httpRequest.patch(`/article-comments/${id}`, dto);
			} else if (type === "reply") {
				await httpRequest.patch(`/article-reply-comments/${id}`, dto);
			}

			onSuccess?.();
			// reset();
		} catch (error) {
			message.error(getErrorMessage(error));
		}
		setIsActionLoading(false);
	};

	const reset = () => {
		setType("");
		form.resetFields();
		setShowModalAdd(false);
		setTempComment(undefined);
		setIsActionLoading(false);
	};
	return (
		<Spin spinning={isLoading || isActionLoading}>
			<Space direction="vertical">
				<Space
					direction="vertical"
					size={18}
				>
					{comments &&
						comments?.length > 0 &&
						comments?.map((comment) => (
							<Row gutter={[12, 12]}>
								<Col
									span={24}
									key={comment.commentId}
								>
									<CommentItem2
										showHideContent={showHideContent}
										comment={comment}
										onClickShowReply={() => {
											const res = {
												[`${comment.commentId}`]: !showReply[comment.commentId],
											};
											setShowReply({
												...showReply,
												...res,
											});
										}}
										onClickRemove={() => {
											confirmModal({
												title: `Do you want to delete that Comment`,
												subtitle: `Are you sure you want to delete this comment? This action cannot be undone.`,
												onOk: () => {
													handleDelete(comment.commentId, "comment");
												},
												danger: true,
												okText: "Yes, Delete",
												cancelText: "No, Cancel",
											});
										}}
										isOpenReply={showReply[comment.commentId]}
										onClickReply={() => {
											setType("reply");
											setTempComment(comment);
											setShowModalAdd(true);
										}}
										onClickApprove={() => {
											confirmModal({
												title: `Approve Comment`,
												subtitle: `Are you sure to approve this comment?`,
												onOk: () => {
													doApproveOrReject(
														comment?.commentId as string,
														"comment",
														EArticleCommentStatus.PUBLISH
													);
												},
												okText: "Approve",
											});
										}}
										onClickReject={() => {
											confirmModal({
												title: `Reject Comment`,
												subtitle: `Are you sure to reject this comment?`,
												onOk: () => {
													doApproveOrReject(
														comment?.commentId as string,
														"comment",
														EArticleCommentStatus.REJECTED
													);
												},
												danger: true,
												okText: "Reject",
											});
										}}
									/>
								</Col>

								{showReply[comment.commentId] && comment.replies.length > 0
									? comment?.replies.map((reply) => (
											<Col
												key={reply.replyId}
												style={{
													paddingLeft: 50,
												}}
												span={24}
											>
												<CommentItem2
													showHideContent={showHideContent}
													onClickRemove={() => {
														confirmModal({
															title: `Do you want to delete that Reply`,
															subtitle: `Are you sure you want to delete this reply? This action cannot be undone.`,
															onOk: () => {
																handleDelete(reply.replyId, "reply");
															},
															danger: true,
															okText: "Yes, Delete",
															cancelText: "No, Cancel",
														});
													}}
													comment={reply}
													isReply
													onClickApprove={() => {
														confirmModal({
															title: `Approve Reply`,
															subtitle: `Are you sure to approve this reply?`,
															onOk: () => {
																doApproveOrReject(
																	reply?.replyId as string,
																	"reply",
																	EArticleReplyStatus.PUBLISH
																);
															},
														});
													}}
													onClickReject={() => {
														confirmModal({
															title: `Reject Reply`,
															subtitle: `Are you sure to reject this reply?`,
															onOk: () => {
																doApproveOrReject(
																	reply?.replyId as string,
																	"reply",
																	EArticleCommentStatus.REJECTED
																);
															},
															danger: true,
														});
													}}
												/>
											</Col>
									  ))
									: null}
							</Row>
						))}
				</Space>
			</Space>

			<ModalAddCommentOrReply
				open={showModalAdd}
				articleId={articleId}
				type={type}
				onClose={() => {
					setShowModalAdd(false);
					setTempComment(undefined);
				}}
				// setIsFetch={setIsFetch}
				onSuccess={onSuccess}
				commentId={tempComment?.commentId}
			/>
		</Spin>
	);
}
